import Store from "../store/store";

export default {
    computed: {
        user() {
            return Store.state.user;
        }
    },
    methods: {
        async getUserBeatTapeItems(beatTapeId, page, search = '') {
            const params = {
                page: page,
                expand: "playlist.tags",
                music_type: "beats"
            }
            if (search) {
                params.search = search
            }

            return this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/collections/${beatTapeId}`, {
                params
            });
        },
        async getUserBeatTapes(page,  {
            selection,
            excluded,
            search,
            cancelToken
        } = {}) {
            const params = {
                page: page,
                order: "latest",
                music_type: "beats"
            }

            if (selection) {
                params.only_ids = selection
            }
            if (excluded) {
                params.exclude_ids = excluded
            }
            if (search) {
                params.search = search
            }
            try {

                return await this.$http.get(`${ab.apiUrl}/users/${this.user.id}/collections`, {
                    params,
                    cancelToken,
                });
            } catch(e) {
                console.log(e)
            }

        },
        async getAllSelectedItems(selection) {
            const response = await this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/collections/ids`, {
                params: {
                    ids: selection
                }
            });
            
            // Order items according to the selection order
            const orderedIds = selection.split(',');
            response.data.items = orderedIds
                .map(id => response.data.items.find(item => item.id === parseInt(id)))
                .filter(Boolean);
                
            return response;
        },
        async getDefaultBeatTapes() {
            return await this.$http.get(`${ab.apiUrl}/users/${ab.user.id}/collections`, { params: {
                    music_type: "beats",
                    limit: 4,
                }})
        }
    }

};
